import { enumOptions } from '@utils/enumOptions';

export const modelTypes = {
  PROVIDER: 'PROVIDER',
  FACILITY: 'FACILITY',
  CASE: 'CASE',
  CLIENT: 'CLIENT',
  MESSAGE_TEMPLATE: 'MESSAGE_TEMPLATE',
  COMPANY: 'COMPANY',
  AUTHORIZATION: 'AUTHORIZATION',
  USER: 'USER',
  CLAIM: 'CLAIM',
  ADDRESS: 'ADDRESS',
  CONTACT: 'CONTACT',
  ACTIVITY: 'ACTIVITY',
  ACTIVITY_TYPE: 'ACTIVITY_TYPE',
  ASSET: 'ASSET',
  AUTHORIZATION_LINK: 'AUTHORIZATION_LINK',
  CONTRACT: 'CONTRACT',
  CPT: 'CPT',
  CREDENTIAL: 'CREDENTIAL',
  HEALTH_PLAN: 'HEALTH_PLAN',
  LIST_ITEM: 'LIST_ITEM',
  LIST_TYPE: 'LIST_TYPE',
  LOCATION: 'LOCATION',
  MESSAGE: 'MESSAGE',
  INTERNAL_OVERSIGHT: 'INTERNAL_OVERSIGHT',
  OCCUPATION: 'OCCUPATION',
  OTR: 'OTR',
  POSTAL: 'POSTAL',
  RATE: 'RATE',
  STAFF: 'STAFF',
  SUPERVISORY_CONSULT: 'SUPERVISORY_CONSULT',
  TASK: 'TASK',
  CMS_POST: 'CMS_POST',
  CMS_POST_BLOCK: 'CMS_POST_BLOCK',
};

export const modelTypeLabels = {
  [modelTypes.PROVIDER]: 'Provider',
  [modelTypes.FACILITY]: 'Facility',
  [modelTypes.CASE]: 'Case',
  [modelTypes.CLIENT]: 'Client',
  [modelTypes.MESSAGE_TEMPLATE]: 'Message Template',
  [modelTypes.COMPANY]: 'Company',
  [modelTypes.AUTHORIZATION]: 'Authorization',
  [modelTypes.USER]: 'User',
  [modelTypes.CLAIM]: 'Claim',
  [modelTypes.ADDRESS]: 'Address',
  [modelTypes.CONTACT]: 'Contact',
  [modelTypes.ACTIVITY]: 'Activity',
  [modelTypes.ACTIVITY_TYPE]: 'Activity type',
  [modelTypes.ASSET]: 'Asset',
  [modelTypes.AUTHORIZATION_LINK]: 'Authorization link',
  [modelTypes.CONTRACT]: 'Contract',
  [modelTypes.CPT]: 'CPT',
  [modelTypes.CREDENTIAL]: 'Credential',
  [modelTypes.HEALTH_PLAN]: 'Health plan',
  [modelTypes.LIST_ITEM]: 'List item',
  [modelTypes.LIST_TYPE]: 'List type',
  [modelTypes.LOCATION]: 'Location',
  [modelTypes.MESSAGE]: 'Message',
  [modelTypes.INTERNAL_OVERSIGHT]: 'Internal oversight',
  [modelTypes.OCCUPATION]: 'Occupation',
  [modelTypes.OTR]: 'OTR',
  [modelTypes.POSTAL]: 'Postal',
  [modelTypes.RATE]: 'Rate',
  [modelTypes.STAFF]: 'Staff',
  [modelTypes.SUPERVISORY_CONSULT]: 'Supervisory consult',
  [modelTypes.TASK]: 'Task',
  [modelTypes.CMS_POST]: 'Cms post',
};

export const modelTypesFull = {
  [modelTypes.PROVIDER]: 'App\\Models\\Provider',
  [modelTypes.FACILITY]: 'App\\Models\\Facility',
  [modelTypes.CASE]: 'App\\Models\\Cases',
  [modelTypes.CLIENT]: 'App\\Models\\Client',
  [modelTypes.MESSAGE_TEMPLATE]: 'App\\Models\\MessageTemplate',
  [modelTypes.COMPANY]: 'App\\Models\\Company',
  [modelTypes.AUTHORIZATION]: 'App\\Models\\Authorization',
  [modelTypes.USER]: 'App\\Models\\User',
  [modelTypes.CLAIM]: 'App\\Models\\Claim',
  [modelTypes.ADDRESS]: 'App\\Models\\Address',
  [modelTypes.CONTACT]: 'App\\Models\\Contact',
  [modelTypes.ACTIVITY]: 'App\\Models\\Activity',
  [modelTypes.ACTIVITY_TYPE]: 'App\\Models\\ActivityType',
  [modelTypes.ASSET]: 'App\\Models\\Asset',
  [modelTypes.AUTHORIZATION_LINK]: 'App\\Models\\AuthorizationLink',
  [modelTypes.CONTRACT]: 'App\\Models\\Contract',
  [modelTypes.CPT]: 'App\\Models\\CPT',
  [modelTypes.CREDENTIAL]: 'App\\Models\\Credential',
  [modelTypes.HEALTH_PLAN]: 'App\\Models\\HealthPlan',
  [modelTypes.LIST_ITEM]: 'App\\Models\\ListItem',
  [modelTypes.LIST_TYPE]: 'App\\Models\\ListType',
  [modelTypes.LOCATION]: 'App\\Models\\Location',
  [modelTypes.MESSAGE]: 'App\\Models\\Message',
  [modelTypes.INTERNAL_OVERSIGHT]: 'App\\Models\\InternalOversight',
  [modelTypes.OCCUPATION]: 'App\\Models\\Occupation',
  [modelTypes.OTR]: 'App\\Models\\OTR',
  [modelTypes.POSTAL]: 'App\\Models\\Postal',
  [modelTypes.RATE]: 'App\\Models\\Rate',
  [modelTypes.STAFF]: 'App\\Models\\Staff',
  [modelTypes.SUPERVISORY_CONSULT]: 'App\\Models\\SupervisoryConsult',
  [modelTypes.TASK]: 'App\\Models\\Task',
};

export const modelTypesFullLabels = {
  [modelTypesFull.PROVIDER]: modelTypeLabels.PROVIDER,
  [modelTypesFull.FACILITY]: modelTypeLabels.FACILITY,
  [modelTypesFull.CASE]: modelTypeLabels.CASE,
  [modelTypesFull.CLIENT]: modelTypeLabels.CLIENT,
  [modelTypesFull.MESSAGE_TEMPLATE]: modelTypeLabels.MESSAGE_TEMPLATE,
  [modelTypesFull.COMPANY]: modelTypeLabels.COMPANY,
  [modelTypesFull.AUTHORIZATION]: modelTypeLabels.AUTHORIZATION,
  [modelTypesFull.USER]: modelTypeLabels.USER,
  [modelTypesFull.CLAIM]: modelTypeLabels.CLAIM,
  [modelTypesFull.ADDRESS]: modelTypeLabels.ADDRESS,
  [modelTypesFull.CONTACT]: modelTypeLabels.CONTACT,
  [modelTypesFull.ACTIVITY]: modelTypeLabels.ACTIVITY,
  [modelTypesFull.ACTIVITY_TYPE]: modelTypeLabels.ACTIVITY_TYPE,
  [modelTypesFull.ASSET]: modelTypeLabels.ASSET,
  [modelTypesFull.AUTHORIZATION_LINK]: modelTypeLabels.AUTHORIZATION_LINK,
  [modelTypesFull.CONTRACT]: modelTypeLabels.CONTRACT,
  [modelTypesFull.CPT]: modelTypeLabels.CPT,
  [modelTypesFull.CREDENTIAL]: modelTypeLabels.CREDENTIAL,
  [modelTypesFull.HEALTH_PLAN]: modelTypeLabels.HEALTH_PLAN,
  [modelTypesFull.LIST_ITEM]: modelTypeLabels.LIST_ITEM,
  [modelTypesFull.LIST_TYPE]: modelTypeLabels.LIST_TYPE,
  [modelTypesFull.LOCATION]: modelTypeLabels.LOCATION,
  [modelTypesFull.MESSAGE]: modelTypeLabels.MESSAGE,
  [modelTypesFull.INTERNAL_OVERSIGHT]: modelTypeLabels.INTERNAL_OVERSIGHT,
  [modelTypesFull.OCCUPATION]: modelTypeLabels.OCCUPATION,
  [modelTypesFull.OTR]: modelTypeLabels.OTR,
  [modelTypesFull.POSTAL]: modelTypeLabels.POSTAL,
  [modelTypesFull.RATE]: modelTypeLabels.RATE,
  [modelTypesFull.STAFF]: modelTypeLabels.STAFF,
  [modelTypesFull.SUPERVISORY_CONSULT]: modelTypeLabels.SUPERVISORY_CONSULT,
  [modelTypesFull.TASK]: modelTypeLabels.TASK,
};

export const modelTypeOptions = enumOptions(modelTypeLabels);
export const modelTypeFullOptions = enumOptions(modelTypesFullLabels);

export const modelChunksUid = [
  modelTypesFull.CASE,
  modelTypesFull.AUTHORIZATION,
  modelTypesFull.CLAIM,
  modelTypesFull.OTR,
];

export const uidPatterns = {
  CA: 'CA',
  AU: 'AU',
  CL: 'CL',
  OT: 'OT',
};

export const uidPatternMask = {
  [uidPatterns.CA]: [
    [0, 2],
    [2, 6],
    [6, 12],
  ],
  [uidPatterns.AU]: [
    [0, 2],
    [2, 11],
    [11, 14],
  ],
  [uidPatterns.CL]: [
    [0, 2],
    [2, 6],
    [6, 10],
  ],
  [uidPatterns.OT]: [
    [0, 2],
    [2, 6],
    [6, 10],
  ],
};
